<template>
  <div style="display: inline-block">
    <el-dialog :visible.sync="dialog" :close-on-click-modal="false" :title="title" class="dialog" @close="cancel">
      <el-form ref="form" :model="form" :rules="rules" size="small">
        <el-form-item label="旧密码" prop="oldPass">
          <el-input v-model="form.oldPass" type="password" auto-complete="off"/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input v-model="form.newPass" type="password" auto-complete="off"/>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPass">
          <el-input v-model="form.confirmPass" type="password" auto-complete="off"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" @click="doSubmit">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store'
import { updatePass } from '@/api/user'
import request from '@/utils/request'
export default {
  data() {
    const confirmPass = (rule, value, callback) => {
      if (value) {
        if (this.form.newPass !== value) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请再次输入密码'))
      }
    }
    return {
      tenantId:'',
      loading: false, dialog: false, title: '修改密码', form: { oldPass: '', newPass: '', confirmPass: '' },
      rules: {
        oldPass: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPass: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, validator: confirmPass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
          this.tenantId = res.tenant.id
          this.projectColor = res.tenant.projectColor
          this.schoolname = res.tenant.tenantName
          this.schoolHname = res.tenant.tenantHName
          this.schoollogo = res.tenant.tenantHLogo
      })
    },
    cancel() {
      this.resetForm()
      this.getinfo();
    },
    doSubmit() {
      if(this.tenantId == 13){
        this.$notify({
          message:'抱歉！您不可以修改密码',
          type:'error',
          duration: 1500
        })
      }else{
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true
            updatePass(this.form).then(res => {
              if(res.code == 501){
                this.$notify({
                  message: res.msg,
                  type: 'error',
                  duration: 1500
                })
                this.loading = false;
              }else{
                this.resetForm()
                this.$notify({
                  message: '密码修改成功，请重新登录',
                  type: 'success',
                  duration: 1500
                })
                setTimeout(() => {
                  store.dispatch('LogOutT').then(() => {
                    this.reload() // 为了重新实例化vue-router对象 避免bug
                    this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
                  })
                }, 1500)
                this.loading = false;
              }
            }).catch(err => {
              this.loading = false;
              console.log(err.response.data.message)
            })
          } else {
            return false
          }
        })
      }
    },
    resetForm() {
      this.dialog = false
      this.$refs['form'].resetFields()
      this.form = { oldPass: '', newPass: '', confirmPass: '' }
    }
  }
}
</script>

<style scoped>
  .el-form-item{
    border-bottom: none;
  }

  .dialog /deep/ .el-dialog{
    margin-top: 0 !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    padding: 12px 14px 14px 14px;
    border-radius: 4px;
  }
  .dialog /deep/ .el-dialog__header{
    padding: 0;
    text-align: center;
    margin-bottom: 12px;
  }
  .dialog /deep/ .el-dialog__header .el-dialog__headerbtn{
    height: 14px;
    float: right;
    top: 15px;
    right: 14px;
  }
  .dialog /deep/ .el-dialog__header .el-dialog__headerbtn .el-icon-close{
    float: left;
    width: 14px;
    height: 14px;
    background: url(../../../../assets/images/newimg/close.png) no-repeat;
  }
  .dialog /deep/ .el-dialog__body{
    padding: 0;
  }
  .dialog /deep/ .el-dialog__body .el-form-item__label{
    line-height: unset;
    margin-bottom: 7px;
  }
  .dialog /deep/ .el-dialog__body .el-input--small{
    font-size:14px;
    width: 100% !important;
  }
  .dialog /deep/ .el-input--small .el-input__inner{
    border-radius: 2px;
  }
  .dialog /deep/ .el-dialog__footer{
    padding: 0;
    text-align: center;
  }
  .dialog /deep/ .el-dialog__footer .el-button--default{
    font-size: 14px;
    padding: 8px 30px;
    background-color: #2174ff;
    color: #fff;
    border-color: #2174ff;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/center/updatePass.vue